module.exports = __webpack_public_path__ + "img/118.77b6e362.jpg";